'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _felaBindings = require('fela-bindings');

var _withTheme = require('./withTheme');

var _withTheme2 = _interopRequireDefault(_withTheme);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

exports.default = (0, _felaBindings.createComponentFactory)(_react.createElement, _withTheme2.default, _defineProperty({
  renderer: _propTypes2.default.object
}, _felaBindings.THEME_CHANNEL, _propTypes2.default.object), true);